import { TextAlignType, TextVerticalAlign, TextWritingType, type ISize, type VectorTextInfo } from '@/version-types';
import { DEFAULT_FONT_FAMILY } from '@/version-types/font';

/**
 * 创建矢量图层默认文本信息
 * @param layer - 矢量图层
 * @param override - 覆盖默认值
 * @returns - 文本信息
 */
export const createDefaultVectorLayerTextInfo = (layerSize: ISize, override: Partial<VectorTextInfo> = {}) => {
    const { width, height } = layerSize;
    const defaultFontSize = Math.round(width / 10);

    const ret: VectorTextInfo = {
        text: '',
        fontFamily: DEFAULT_FONT_FAMILY().name,
        fontSize: defaultFontSize >= height ? height * 0.6 : defaultFontSize,
        color: '#000000ff',
        bold: false,
        italic: false,
        lineSpacing: 1.4,
        letterSpacing: 0,
        lineThrough: false,
        underline: false,
        textAlign: TextAlignType.CENTER,
        writingMode: TextWritingType.HORIZONTAL_TB,
        listStyle: '',
        opacity: 1,
        verticalAlign: TextVerticalAlign.CENTER,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
    };

    return {
        ...ret,
        ...override,
    };
};

/**
 * 获取文本视图选择器
 * @param layerID - 矢量图层 ID
 * @returns
 */
export const getTextContentDOMSelector = (layerID: string) => `[data-text-content-id="${layerID}"]`;
